document.addEventListener("DOMContentLoaded", function () {
  // WOVNの初期化
  if (window.WOVN) WOVN.io.manualStart();

  // WOVNのUIが準備完了するまで待機
  const waitForWovn = setInterval(function () {
    const wovnContainer = document.querySelector(
      '.wovn-languages[data-ready="true"]'
    );

    if (wovnContainer && wovnContainer.querySelector(".wovn-switch")) {
      clearInterval(waitForWovn);
      transformToDropdown();
    }
  }, 100);

  function transformToDropdown() {
    const wovnContainer = document.querySelector(".wovn-languages");
    const container = wovnContainer.querySelector(".container");
    const originalSwitches = container.querySelectorAll(
      ".wovn-switch-template.wovn-switch"
    );

    // 現在選択されている言語を取得
    const selectedSwitch = container.querySelector(".wovn-switch.selected");
    const currentLang = selectedSwitch ? selectedSwitch.textContent : "English";

    // 元の要素を保持
    const switchesData = Array.from(originalSwitches).map((switch_) => ({
      originalElement: switch_,
      value: switch_.getAttribute("data-value"),
      text: switch_.textContent,
      isSelected: switch_.classList.contains("selected"),
    }));

    // 元のcontainerを非表示
    container.style.display = "none";

    // 新しい構造を作成
    // 1. 現在の言語を表示するspan
    const stateSpan = document.createElement("span");
    stateSpan.className = "wovn-state";
    stateSpan.textContent = currentLang;

    // 2. 言語リスト（ul）
    const langList = document.createElement("ul");
    langList.className = "wovn-lang-list";
    langList.style.visibility = "hidden";
    langList.style.opacity = "0";

    // 各言語項目（li）を追加
    switchesData.forEach((data) => {
      const langItem = document.createElement("li");
      langItem.className = "wovn-switch" + (data.isSelected ? " selected" : "");
      langItem.setAttribute("data-value", data.value);
      langItem.textContent = data.text;

      // クリック時に元のWOVN要素をクリック
      langItem.addEventListener("click", function (e) {
        e.stopPropagation();

        // 元のWOVN要素をクリックしてイベントをトリガー
        data.originalElement.click();

        // UIの更新
        setTimeout(() => {
          // 選択状態を更新
          langList.querySelectorAll(".wovn-switch").forEach((item) => {
            item.classList.remove("selected");
          });
          langItem.classList.add("selected");

          // stateSpanのテキストを更新
          stateSpan.textContent = data.text;

          // ドロップダウンを閉じる
          wovnContainer.classList.remove("is-open");
          wovnContainer.setAttribute("data-open", "false");
          langList.style.visibility = "hidden";
          langList.style.opacity = "0";
        }, 100);
      });

      langList.appendChild(langItem);
    });

    // wovnContainerに追加
    wovnContainer.appendChild(stateSpan);
    wovnContainer.appendChild(langList);

    // data-open属性を初期化
    wovnContainer.setAttribute("data-open", "false");

    // stateSpanクリックで開閉
    // wovnContainerクリックで開閉（疑似要素:afterも含む）
    wovnContainer.addEventListener("click", function (e) {
      // langList内のクリックは除外
      if (langList.contains(e.target)) {
        return;
      }

      e.stopPropagation();

      const isOpen = wovnContainer.getAttribute("data-open") === "true";

      if (isOpen) {
        // 閉じる
        wovnContainer.classList.remove("is-open");
        wovnContainer.setAttribute("data-open", "false");
        langList.style.visibility = "hidden";
        langList.style.opacity = "0";
      } else {
        // 開く
        wovnContainer.classList.add("is-open");
        wovnContainer.setAttribute("data-open", "true");
        langList.style.visibility = "visible";
        langList.style.opacity = "1";
      }
    });

    // 外部クリックで閉じる
    document.addEventListener("click", function (e) {
      if (!wovnContainer.contains(e.target)) {
        wovnContainer.classList.remove("is-open");
        wovnContainer.setAttribute("data-open", "false");
        langList.style.visibility = "hidden";
        langList.style.opacity = "0";
      }
    });

    // 言語変更の監視
    const observer = new MutationObserver(function (mutations) {
      const originalSelected = container.querySelector(".wovn-switch.selected");
      if (originalSelected) {
        const selectedValue = originalSelected.getAttribute("data-value");
        const selectedText = originalSelected.textContent;

        // 新しいUIの選択状態を更新
        langList.querySelectorAll(".wovn-switch").forEach((item) => {
          if (item.getAttribute("data-value") === selectedValue) {
            item.classList.add("selected");
            stateSpan.textContent = item.textContent;
          } else {
            item.classList.remove("selected");
          }
        });
      }
    });

    // 元の要素の変更を監視
    originalSwitches.forEach((switch_) => {
      observer.observe(switch_, { attributes: true });
    });
  }
});
